// In-memory mock server matching the Bar Management backend contract.
// Used when REACT_APP_USE_MOCK is "true" or when the real backend is unreachable.

import { currentBusinessDate, isInBusinessDay } from "../utils/businessDay";

const LS_KEY = "bms_mock_db_v3";

const initialDb = () => ({
  nextIds: {
    user: 4,
    bottleType: 4,
    bottleCompany: 4,
    bottleProduct: 8,
    biteCategory: 4,
    biteProduct: 8,
    batch: 6,
    sale: 1001,
    payment: 5001,
    saleItem: 9001,
    correction: 1,
    adjustment: 1,
    audit: 100,
    recipient: 3,
    notifLog: 1,
    cashSession: 10,
  },
  users: [
    { userId: 1, fullName: "Sahan Owner", username: "owner", password: "owner", roleName: "OWNER", email: "owner@bar.lk", whatsappNumber: null, status: "ACTIVE", createdAt: new Date().toISOString() },
    { userId: 2, fullName: "Nimal Admin", username: "admin", password: "admin", roleName: "ADMIN", email: "admin@bar.lk", whatsappNumber: null, status: "ACTIVE", createdAt: new Date().toISOString() },
    { userId: 3, fullName: "Kasun Cashier", username: "cashier", password: "cashier", roleName: "BAR_CASHIER", email: null, whatsappNumber: null, status: "ACTIVE", createdAt: new Date().toISOString() },
  ],
  bottleTypes: [
    { bottleTypeId: 1, typeName: "ARRACK", status: "ACTIVE" },
    { bottleTypeId: 2, typeName: "WHISKY", status: "ACTIVE" },
    { bottleTypeId: 3, typeName: "BEER", status: "ACTIVE" },
  ],
  bottleCompanies: [
    { companyId: 1, companyName: "DCSL", status: "ACTIVE" },
    { companyId: 2, companyName: "Lion", status: "ACTIVE" },
    { companyId: 3, companyName: "Rockland", status: "ACTIVE" },
  ],
  bottleProducts: [
    { bottleId: 1, bottleName: "DCSL Old Arrack", bottleTypeId: 1, companyId: 1, bottleSize: "750ml", sellingPrice: 1900, lowStockLevel: 10, status: "ACTIVE" },
    { bottleId: 2, bottleName: "Rockland Coconut Arrack", bottleTypeId: 1, companyId: 3, bottleSize: "750ml", sellingPrice: 2200, lowStockLevel: 8, status: "ACTIVE" },
    { bottleId: 3, bottleName: "Lion Lager Beer", bottleTypeId: 3, companyId: 2, bottleSize: "625ml", sellingPrice: 480, lowStockLevel: 24, status: "ACTIVE" },
    { bottleId: 4, bottleName: "Lion Strong Beer", bottleTypeId: 3, companyId: 2, bottleSize: "625ml", sellingPrice: 520, lowStockLevel: 24, status: "ACTIVE" },
    { bottleId: 5, bottleName: "Johnnie Walker Red", bottleTypeId: 2, companyId: 1, bottleSize: "750ml", sellingPrice: 9500, lowStockLevel: 4, status: "ACTIVE" },
    { bottleId: 6, bottleName: "Jameson", bottleTypeId: 2, companyId: 1, bottleSize: "750ml", sellingPrice: 11500, lowStockLevel: 3, status: "ACTIVE" },
    { bottleId: 7, bottleName: "Mendis Special Arrack", bottleTypeId: 1, companyId: 3, bottleSize: "750ml", sellingPrice: 1750, lowStockLevel: 10, status: "ACTIVE" },
  ],
  biteCategories: [
    { biteCategoryId: 1, categoryName: "DEVILLED", status: "ACTIVE" },
    { biteCategoryId: 2, categoryName: "FRIED", status: "ACTIVE" },
    { biteCategoryId: 3, categoryName: "GRILLED", status: "ACTIVE" },
  ],
  biteProducts: [
    { biteId: 1, biteName: "Chicken Devil", biteCategoryId: 1, sellingPrice: 1200, status: "ACTIVE" },
    { biteId: 2, biteName: "Cuttle Fish Devil", biteCategoryId: 1, sellingPrice: 1500, status: "ACTIVE" },
    { biteId: 3, biteName: "Pork Devil", biteCategoryId: 1, sellingPrice: 1800, status: "ACTIVE" },
    { biteId: 4, biteName: "Devilled Mushroom", biteCategoryId: 1, sellingPrice: 950, status: "ACTIVE" },
    { biteId: 5, biteName: "Chicken Wings", biteCategoryId: 2, sellingPrice: 1100, status: "ACTIVE" },
    { biteId: 6, biteName: "Fried Cashew", biteCategoryId: 2, sellingPrice: 700, status: "ACTIVE" },
    { biteId: 7, biteName: "Grilled Chicken Platter", biteCategoryId: 3, sellingPrice: 2100, status: "ACTIVE" },
  ],
  stockBatches: [
    { batchId: 1, batchCode: "B-0001", bottleId: 1, purchaseTypeCode: "D", purchaseQuantity: 30, remainingQuantity: 22, costPrice: 1450, sellingPrice: 1900, purchaseDate: "2026-01-02", invoiceNumber: "INV-1001", sourceReference: "REF-A", note: "Initial", addedByName: "Sahan Owner", status: "ACTIVE" },
    { batchId: 2, batchCode: "B-0002", bottleId: 1, purchaseTypeCode: "O", purchaseQuantity: 20, remainingQuantity: 20, costPrice: 1500, sellingPrice: 1900, purchaseDate: "2026-01-10", invoiceNumber: "INV-1010", sourceReference: "REF-B", note: "Restock", addedByName: "Sahan Owner", status: "ACTIVE" },
    { batchId: 3, batchCode: "B-0003", bottleId: 3, purchaseTypeCode: "D", purchaseQuantity: 96, remainingQuantity: 8, costPrice: 340, sellingPrice: 480, purchaseDate: "2026-01-04", invoiceNumber: "INV-1011", sourceReference: "REF-C", note: "Beer crate", addedByName: "Nimal Admin", status: "ACTIVE" },
    { batchId: 4, batchCode: "B-0004", bottleId: 5, purchaseTypeCode: "D", purchaseQuantity: 12, remainingQuantity: 3, costPrice: 7800, sellingPrice: 9500, purchaseDate: "2026-01-05", invoiceNumber: "INV-1012", sourceReference: "REF-D", note: "JW Red", addedByName: "Sahan Owner", status: "ACTIVE" },
    { batchId: 5, batchCode: "B-0005", bottleId: 2, purchaseTypeCode: "O", purchaseQuantity: 24, remainingQuantity: 19, costPrice: 1650, sellingPrice: 2200, purchaseDate: "2026-01-08", invoiceNumber: "INV-1013", sourceReference: "REF-E", note: null, addedByName: "Nimal Admin", status: "ACTIVE" },
  ],
  sales: [
    { saleId: 1000, saleCode: "S-1000", cashierId: 3, cashierName: "Kasun Cashier", createdAt: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString(), subTotal: 4280, discountAmount: 0, serviceChargeAmount: 0, taxAmount: 0, grandTotal: 4280, status: "COMPLETED",
      items: [
        { saleItemId: 9000, itemType: "BOTTLE", itemId: 1, itemName: "DCSL Old Arrack 750ml", quantity: 1, unitPrice: 1900, discountAmount: 0, totalPrice: 1900 },
        { saleItemId: 9001, itemType: "BOTTLE", itemId: 3, itemName: "Lion Lager Beer 625ml", quantity: 2, unitPrice: 480, discountAmount: 0, totalPrice: 960 },
        { saleItemId: 9002, itemType: "BITE", itemId: 1, itemName: "Chicken Devil", quantity: 1, unitPrice: 1200, discountAmount: 0, totalPrice: 1200 },
        { saleItemId: 9003, itemType: "BITE", itemId: 6, itemName: "Fried Cashew", quantity: 1, unitPrice: 220, discountAmount: 0, totalPrice: 220 },
      ],
      payments: [
        { paymentId: 5000, paymentMethod: "CASH", amount: 4280, referenceNumber: null, note: null },
      ],
      profit: 1420,
    },
  ],
  corrections: [],
  adjustments: [
    { adjustmentId: 1, batchId: 1, batchCode: "B-0001", adjustmentType: "DAMAGE", quantity: -1, reason: "Bottle dropped during handling", createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString() },
    { adjustmentId: 2, batchId: 3, batchCode: "B-0003", adjustmentType: "COMPLIMENTARY", quantity: -2, reason: "Complimentary to regular customer", createdAt: new Date(Date.now() - 1000 * 60 * 60 * 12).toISOString() },
  ],
  auditLogs: [
    { auditId: 1, userId: 1, userName: "Sahan Owner", actionType: "LOGIN", moduleName: "auth", recordId: 1, oldValue: null, newValue: null, reason: "Owner login", createdAt: new Date().toISOString() },
    { auditId: 2, userId: 2, userName: "Nimal Admin", actionType: "BOTTLE_STOCK_ADDED", moduleName: "stock", recordId: 3, oldValue: null, newValue: "qty=96", reason: "Initial stock", createdAt: new Date().toISOString() },
  ],
  notificationRecipients: [
    { recipientId: 1, userId: 1, userName: "Sahan Owner", recipientType: "EMAIL", recipientValue: "owner@bar.lk", receiveLowStock: true, receiveDailyReport: true, status: "ACTIVE" },
    { recipientId: 2, userId: null, userName: null, recipientType: "WHATSAPP", recipientValue: "+94771234567", receiveLowStock: true, receiveDailyReport: false, status: "ACTIVE" },
  ],
  notificationLogs: [],
  cashSessions: [
    { cashSessionId: 9, cashierId: 3, cashierName: "Kasun Cashier", openedAt: new Date(Date.now() - 1000 * 60 * 60 * 6).toISOString(), openingCashAmount: 10000, closedAt: new Date(Date.now() - 1000 * 60 * 60 * 1).toISOString(), cashSalesAmount: 4280, expectedClosingCash: 14280, actualClosingCash: 14250, cashDifference: -30, status: "CLOSED" },
  ],
});

const load = () => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) {
      const db = initialDb();
      localStorage.setItem(LS_KEY, JSON.stringify(db));
      return db;
    }
    return JSON.parse(raw);
  } catch {
    return initialDb();
  }
};
const save = (db) => localStorage.setItem(LS_KEY, JSON.stringify(db));
const nextId = (db, key) => {
  db.nextIds[key] = (db.nextIds[key] || 1) + 1;
  return db.nextIds[key];
};

export const resetMockDb = () => {
  localStorage.removeItem(LS_KEY);
};

const ok = (data, message = "OK") => ({ status: 200, data: { success: true, message, data } });
const created = (data) => ({ status: 201, data: { success: true, message: "Created", data } });
const bad = (message, status = 400) => ({ status, data: { success: false, message } });

const nameOf = (list, idKey, nameKey, id) => list.find((x) => x[idKey] === id)?.[nameKey];

const enrichBottleProduct = (db, p) => ({
  ...p,
  bottleTypeName: nameOf(db.bottleTypes, "bottleTypeId", "typeName", p.bottleTypeId),
  companyName: nameOf(db.bottleCompanies, "companyId", "companyName", p.companyId),
  availableQuantity: db.stockBatches
    .filter((b) => b.bottleId === p.bottleId && b.status === "ACTIVE")
    .reduce((s, b) => s + b.remainingQuantity, 0),
});

const enrichBite = (db, p) => ({
  ...p,
  biteCategoryName: nameOf(db.biteCategories, "biteCategoryId", "categoryName", p.biteCategoryId),
});

const enrichBatch = (db, b) => ({
  ...b,
  bottleName: nameOf(db.bottleProducts, "bottleId", "bottleName", b.bottleId),
});

const parseDateOnly = (iso) => (iso ? iso.slice(0, 10) : null);

export const handleMockRequest = ({ method, url, data, params }) => {
  const db = load();
  const m = (method || "GET").toUpperCase();
  // strip query, normalize
  const path = url.split("?")[0];

  // AUTH
  if (path === "/api/auth/login" && m === "POST") {
    const { username, password } = data || {};
    const user = db.users.find((u) => u.username === username);
    if (!user || user.password !== password) return bad("Invalid credentials", 401);
    if (user.status !== "ACTIVE") return bad("User inactive", 403);
    db.auditLogs.unshift({
      auditId: nextId(db, "audit"),
      userId: user.userId,
      userName: user.fullName,
      actionType: "LOGIN",
      moduleName: "auth",
      recordId: user.userId,
      oldValue: null,
      newValue: null,
      reason: "Login",
      createdAt: new Date().toISOString(),
    });
    save(db);
    return ok({
      accessToken: `mock.${btoa(user.username)}.${Date.now()}`,
      tokenType: "Bearer",
      userId: user.userId,
      fullName: user.fullName,
      username: user.username,
      roleName: user.roleName,
    });
  }
  if (path === "/api/auth/me" && m === "GET") {
    const u = db.users.find((x) => x.userId === Number(params?.userId)) || db.users[0];
    return ok(u);
  }

  // USERS
  if (path === "/api/admin/users" && m === "GET") return ok(db.users);
  if (path === "/api/admin/users" && m === "POST") {
    if (db.users.find((u) => u.username === data.username)) return bad("Username already exists");
    const user = { userId: nextId(db, "user"), ...data, status: "ACTIVE", createdAt: new Date().toISOString() };
    db.users.push(user);
    save(db);
    return created(user);
  }
  let mt;
  if ((mt = path.match(/^\/api\/admin\/users\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const u = db.users.find((x) => x.userId === id);
    if (!u) return bad("User not found", 404);
    u.status = params?.status || data?.status || (u.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(u);
  }
  if ((mt = path.match(/^\/api\/admin\/users\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const u = db.users.find((x) => x.userId === id);
    if (!u) return bad("User not found", 404);
    // username and password are NOT editable here.
    if (data.fullName != null) u.fullName = data.fullName;
    if (data.roleName != null) u.roleName = data.roleName;
    if (data.email !== undefined) u.email = data.email || null;
    if (data.whatsappNumber !== undefined) u.whatsappNumber = data.whatsappNumber || null;
    save(db);
    return ok(u);
  }
  if ((mt = path.match(/^\/api\/admin\/users\/(\d+)$/)) && m === "DELETE") {
    const id = Number(mt[1]);
    const u = db.users.find((x) => x.userId === id);
    if (!u) return bad("User not found", 404);
    // Soft delete — mark INACTIVE (matches what the real backend should do).
    u.status = "INACTIVE";
    save(db);
    return ok(u);
  }

  // BOTTLE TYPES
  if (path === "/api/admin/bottle-types" && m === "GET") return ok(db.bottleTypes);
  if (path === "/api/admin/bottle-types" && m === "POST") {
    const t = { bottleTypeId: nextId(db, "bottleType"), typeName: data.typeName, status: "ACTIVE" };
    db.bottleTypes.push(t);
    save(db);
    return created(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-types\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const t = db.bottleTypes.find((x) => x.bottleTypeId === id);
    if (!t) return bad("Bottle type not found", 404);
    if (data.typeName != null) t.typeName = data.typeName;
    save(db);
    return ok(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-types\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const t = db.bottleTypes.find((x) => x.bottleTypeId === id);
    if (!t) return bad("Bottle type not found", 404);
    t.status = params?.status || (t.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-types\/(\d+)$/)) && m === "DELETE") {
    const id = Number(mt[1]);
    const idx = db.bottleTypes.findIndex((x) => x.bottleTypeId === id);
    if (idx === -1) return bad("Bottle type not found", 404);
    db.bottleTypes[idx].status = "INACTIVE";
    save(db);
    return ok(db.bottleTypes[idx]);
  }

  // BOTTLE COMPANIES
  if (path === "/api/admin/bottle-companies" && m === "GET") return ok(db.bottleCompanies);
  if (path === "/api/admin/bottle-companies" && m === "POST") {
    const t = { companyId: nextId(db, "bottleCompany"), companyName: data.companyName, status: "ACTIVE" };
    db.bottleCompanies.push(t);
    save(db);
    return created(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-companies\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const t = db.bottleCompanies.find((x) => x.companyId === id);
    if (!t) return bad("Bottle company not found", 404);
    if (data.companyName != null) t.companyName = data.companyName;
    save(db);
    return ok(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-companies\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const t = db.bottleCompanies.find((x) => x.companyId === id);
    if (!t) return bad("Bottle company not found", 404);
    t.status = params?.status || (t.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-companies\/(\d+)$/)) && m === "DELETE") {
    const id = Number(mt[1]);
    const t = db.bottleCompanies.find((x) => x.companyId === id);
    if (!t) return bad("Bottle company not found", 404);
    t.status = "INACTIVE";
    save(db);
    return ok(t);
  }

  // BOTTLE PRODUCTS
  if (path === "/api/admin/bottles/active" && m === "GET") {
    return ok(db.bottleProducts
      .filter((p) => p.status === "ACTIVE")
      .map((p) => enrichBottleProduct(db, p)));
  }
  if (path === "/api/admin/bottles" && m === "GET") {
    return ok(db.bottleProducts.map((p) => enrichBottleProduct(db, p)));
  }
  if (path === "/api/admin/bottles" && m === "POST") {
    const p = { bottleId: nextId(db, "bottleProduct"), ...data, status: "ACTIVE" };
    db.bottleProducts.push(p);
    save(db);
    return created(enrichBottleProduct(db, p));
  }
  if ((mt = path.match(/^\/api\/admin\/bottles\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const p = db.bottleProducts.find((x) => x.bottleId === id);
    if (!p) return bad("Bottle not found", 404);
    Object.assign(p, data);
    save(db);
    return ok(enrichBottleProduct(db, p));
  }
  if ((mt = path.match(/^\/api\/admin\/bottles\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const p = db.bottleProducts.find((x) => x.bottleId === id);
    if (!p) return bad("Bottle not found", 404);
    p.status = params?.status || (p.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(enrichBottleProduct(db, p));
  }

  // BITE CATEGORIES
  if (path === "/api/admin/bite-categories" && m === "GET") return ok(db.biteCategories);
  if (path === "/api/admin/bite-categories" && m === "POST") {
    const t = { biteCategoryId: nextId(db, "biteCategory"), categoryName: data.categoryName, status: "ACTIVE" };
    db.biteCategories.push(t);
    save(db);
    return created(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bite-categories\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const t = db.biteCategories.find((x) => x.biteCategoryId === id);
    if (!t) return bad("Bite category not found", 404);
    if (data.categoryName != null) t.categoryName = data.categoryName;
    save(db);
    return ok(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bite-categories\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const t = db.biteCategories.find((x) => x.biteCategoryId === id);
    if (!t) return bad("Bite category not found", 404);
    t.status = params?.status || (t.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(t);
  }
  if ((mt = path.match(/^\/api\/admin\/bite-categories\/(\d+)$/)) && m === "DELETE") {
    const id = Number(mt[1]);
    const t = db.biteCategories.find((x) => x.biteCategoryId === id);
    if (!t) return bad("Bite category not found", 404);
    t.status = "INACTIVE";
    save(db);
    return ok(t);
  }

  // BITE PRODUCTS
  if (path === "/api/admin/bites/active-stock-tracked" && m === "GET") {
    return ok(db.biteProducts
      .filter((p) => p.status === "ACTIVE" && p.stockTracked === true)
      .map((p) => enrichBite(db, p)));
  }
  if (path === "/api/admin/bites" && m === "GET") return ok(db.biteProducts.map((p) => enrichBite(db, p)));
  if (path === "/api/admin/bites" && m === "POST") {
    const p = { biteId: nextId(db, "biteProduct"), ...data, status: "ACTIVE" };
    db.biteProducts.push(p);
    save(db);
    return created(enrichBite(db, p));
  }
  if ((mt = path.match(/^\/api\/admin\/bites\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const p = db.biteProducts.find((x) => x.biteId === id);
    if (!p) return bad("Bite not found", 404);
    Object.assign(p, data);
    save(db);
    return ok(enrichBite(db, p));
  }
  if ((mt = path.match(/^\/api\/admin\/bites\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const p = db.biteProducts.find((x) => x.biteId === id);
    if (!p) return bad("Bite not found", 404);
    p.status = params?.status || (p.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(enrichBite(db, p));
  }

  // STOCK
  if (path === "/api/admin/bottle-stocks" && m === "GET") {
    return ok(db.stockBatches.map((b) => enrichBatch(db, b)));
  }
  if (path === "/api/admin/bottle-stocks" && m === "POST") {
    const id = nextId(db, "batch");
    const b = {
      batchId: id,
      batchCode: `B-${String(id).padStart(4, "0")}`,
      ...data,
      remainingQuantity: data.purchaseQuantity,
      addedByName: data.addedByName || "Admin",
      status: "ACTIVE",
    };
    db.stockBatches.push(b);
    save(db);
    return created(enrichBatch(db, b));
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-stocks\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const b = db.stockBatches.find((x) => x.batchId === id);
    if (!b) return bad("Batch not found", 404);
    // Track quantity delta so remainingQuantity stays consistent.
    const prevQty = b.purchaseQuantity;
    const consumed = prevQty - b.remainingQuantity;
    const editable = ["bottleId", "purchaseTypeCode", "purchaseQuantity", "costPrice", "sellingPrice", "purchaseDate", "invoiceNumber", "sourceReference", "note"];
    editable.forEach((k) => { if (data[k] !== undefined) b[k] = data[k]; });
    if (data.purchaseQuantity !== undefined) {
      const newRem = Number(data.purchaseQuantity) - consumed;
      if (newRem < 0) return bad("New purchase quantity is less than already-consumed stock");
      b.remainingQuantity = newRem;
    }
    save(db);
    return ok(enrichBatch(db, b));
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-stocks\/(\d+)$/)) && m === "DELETE") {
    const id = Number(mt[1]);
    const b = db.stockBatches.find((x) => x.batchId === id);
    if (!b) return bad("Batch not found", 404);
    // Soft delete — flag INACTIVE so FIFO consumption skips it and the
    // audit trail (sales, adjustments) referencing this batchId stays intact.
    b.status = "INACTIVE";
    save(db);
    return ok(enrichBatch(db, b));
  }
  if (path === "/api/admin/bottle-stocks/adjustments" && m === "POST") {
    const batch = db.stockBatches.find((x) => x.batchId === Number(data.batchId));
    if (!batch) return bad("Batch not found", 404);
    const newRemaining = batch.remainingQuantity + Number(data.quantity);
    if (newRemaining < 0) return bad("Remaining stock cannot go below zero");
    batch.remainingQuantity = newRemaining;
    const adj = { adjustmentId: nextId(db, "adjustment"), batchCode: batch.batchCode, batchId: batch.batchId, ...data, createdAt: new Date().toISOString() };
    db.adjustments.push(adj);
    save(db);
    return created(adj);
  }
  if (path === "/api/admin/bottle-stocks/adjustments" && m === "GET") {
    return ok(db.adjustments);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-stocks\/adjustments\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const adj = db.adjustments.find((x) => x.adjustmentId === id);
    if (!adj) return bad("Adjustment not found", 404);
    const batch = db.stockBatches.find((x) => x.batchId === Number(adj.batchId));
    if (!batch) return bad("Linked batch not found", 404);
    // Roll back the previous quantity, then apply the new one.
    const prevDelta = Number(adj.quantity);
    const newDelta = data.quantity !== undefined ? Number(data.quantity) : prevDelta;
    const newRemaining = batch.remainingQuantity - prevDelta + newDelta;
    if (newRemaining < 0) return bad("Adjustment would make remaining stock negative");
    batch.remainingQuantity = newRemaining;
    if (data.adjustmentType !== undefined) adj.adjustmentType = data.adjustmentType;
    if (data.quantity !== undefined) adj.quantity = newDelta;
    if (data.reason !== undefined) adj.reason = data.reason;
    save(db);
    return ok(adj);
  }
  if ((mt = path.match(/^\/api\/admin\/bottle-stocks\/adjustments\/(\d+)$/)) && m === "DELETE") {
    const id = Number(mt[1]);
    const idx = db.adjustments.findIndex((x) => x.adjustmentId === id);
    if (idx === -1) return bad("Adjustment not found", 404);
    const adj = db.adjustments[idx];
    const batch = db.stockBatches.find((x) => x.batchId === Number(adj.batchId));
    if (batch) {
      // Reverse the stock movement caused by the adjustment.
      batch.remainingQuantity = batch.remainingQuantity - Number(adj.quantity);
      if (batch.remainingQuantity < 0) batch.remainingQuantity = 0;
    }
    db.adjustments.splice(idx, 1);
    save(db);
    return ok({ adjustmentId: id, reversed: true });
  }
  if (path === "/api/admin/bottle-stocks/low-stock" && m === "GET") {
    const list = db.bottleProducts
      .map((p) => enrichBottleProduct(db, p))
      .filter((p) => p.availableQuantity <= p.lowStockLevel);
    return ok(list);
  }

  // POS
  if (path === "/api/pos/bottles" && m === "GET") {
    return ok(
      db.bottleProducts
        .filter((p) => p.status === "ACTIVE")
        .map((p) => enrichBottleProduct(db, p))
        .map(({ costPrice, ...safe }) => safe),
    );
  }
  if (path === "/api/pos/bites" && m === "GET") {
    return ok(db.biteProducts.filter((p) => p.status === "ACTIVE").map((p) => enrichBite(db, p)));
  }
  if (path === "/api/pos/sales" && m === "POST") {
    const items = data.items || [];
    const payments = data.payments || [];
    if (!items.length) return bad("Sale must contain at least one item");
    if (!payments.length) return bad("At least one payment is required");

    let subTotal = 0;
    const expandedItems = [];
    for (const it of items) {
      if (it.itemType === "BOTTLE") {
        const product = db.bottleProducts.find((p) => p.bottleId === it.itemId);
        if (!product) return bad(`Bottle ${it.itemId} not found`, 404);
        const available = db.stockBatches
          .filter((b) => b.bottleId === product.bottleId && b.status === "ACTIVE")
          .reduce((s, b) => s + b.remainingQuantity, 0);
        if (available < it.quantity) return bad(`Insufficient stock for ${product.bottleName}`);
        const total = product.sellingPrice * it.quantity;
        subTotal += total;
        expandedItems.push({
          saleItemId: nextId(db, "saleItem"),
          itemType: "BOTTLE",
          itemId: product.bottleId,
          itemName: `${product.bottleName} ${product.bottleSize}`,
          quantity: it.quantity,
          unitPrice: product.sellingPrice,
          discountAmount: 0,
          totalPrice: total,
        });
      } else {
        const product = db.biteProducts.find((p) => p.biteId === it.itemId);
        if (!product) return bad(`Bite ${it.itemId} not found`, 404);
        const total = product.sellingPrice * it.quantity;
        subTotal += total;
        expandedItems.push({
          saleItemId: nextId(db, "saleItem"),
          itemType: "BITE",
          itemId: product.biteId,
          itemName: product.biteName,
          quantity: it.quantity,
          unitPrice: product.sellingPrice,
          discountAmount: 0,
          totalPrice: total,
        });
      }
    }
    const discountAmount = Number(data.discountAmount || 0);
    const serviceChargeAmount = Number(data.serviceChargeAmount || 0);
    const taxAmount = Number(data.taxAmount || 0);
    const grandTotal = subTotal - discountAmount + serviceChargeAmount + taxAmount;
    const paidTotal = payments.reduce((s, p) => s + Number(p.amount), 0);
    if (Math.abs(paidTotal - grandTotal) > 0.01)
      return bad(`Payment total Rs.${paidTotal.toFixed(2)} does not equal grand total Rs.${grandTotal.toFixed(2)}`);

    // FIFO deduct bottles
    let profit = 0;
    for (const it of expandedItems.filter((x) => x.itemType === "BOTTLE")) {
      let remaining = it.quantity;
      const batches = db.stockBatches
        .filter((b) => b.bottleId === it.itemId && b.status === "ACTIVE")
        .sort((a, b) => (a.purchaseDate || "").localeCompare(b.purchaseDate || "") || a.batchId - b.batchId);
      for (const b of batches) {
        if (remaining <= 0) break;
        const take = Math.min(b.remainingQuantity, remaining);
        b.remainingQuantity -= take;
        remaining -= take;
        profit += (it.unitPrice - b.costPrice) * take;
      }
    }

    const saleId = nextId(db, "sale");
    const sale = {
      saleId,
      saleCode: `S-${saleId}`,
      cashierId: data.cashierId || 3,
      cashierName: data.cashierName || "Kasun Cashier",
      createdAt: new Date().toISOString(),
      subTotal,
      discountAmount,
      serviceChargeAmount,
      taxAmount,
      grandTotal,
      status: "COMPLETED",
      items: expandedItems,
      payments: payments.map((p) => ({ paymentId: nextId(db, "payment"), ...p })),
      profit,
    };
    db.sales.unshift(sale);

    // attribute cash sales to open cash session of cashier
    const cashAmount = payments.filter((p) => p.paymentMethod === "CASH").reduce((s, p) => s + Number(p.amount), 0);
    if (cashAmount > 0) {
      const open = db.cashSessions.find((s) => s.cashierId === sale.cashierId && s.status === "OPEN");
      if (open) {
        open.cashSalesAmount = Number(open.cashSalesAmount || 0) + cashAmount;
        open.expectedClosingCash = Number(open.openingCashAmount) + open.cashSalesAmount;
      }
    }
    save(db);
    return created(sale);
  }
  if ((mt = path.match(/^\/api\/pos\/sales\/(\d+)$/)) && m === "GET") {
    const s = db.sales.find((x) => x.saleId === Number(mt[1]));
    if (!s) return bad("Sale not found", 404);
    return ok(s);
  }
  if (path === "/api/pos/sales/my" && m === "GET") {
    const cid = Number(params?.cashierId);
    return ok(cid ? db.sales.filter((s) => s.cashierId === cid) : db.sales);
  }
  if ((mt = path.match(/^\/api\/pos\/sales\/(\d+)\/correction-request$/)) && m === "POST") {
    const id = Number(mt[1]);
    const s = db.sales.find((x) => x.saleId === id);
    if (!s) return bad("Sale not found", 404);
    if (s.status !== "COMPLETED") return bad("Only completed sales can be corrected");
    s.status = "CORRECTION_REQUESTED";
    const req = {
      requestId: nextId(db, "correction"),
      saleId: id,
      saleCode: s.saleCode,
      requestedByName: data.requestedByName || "Cashier",
      reason: data.reason,
      status: "PENDING",
      reviewedByName: null,
      reviewedAt: null,
      adminNote: null,
      createdAt: new Date().toISOString(),
    };
    db.corrections.unshift(req);
    save(db);
    return created(req);
  }

  // CORRECTIONS
  if (path === "/api/admin/correction-requests" && m === "GET") return ok(db.corrections);
  if ((mt = path.match(/^\/api\/admin\/correction-requests\/(\d+)\/approve$/)) && m === "POST") {
    const id = Number(mt[1]);
    const req = db.corrections.find((x) => x.requestId === id);
    if (!req) return bad("Request not found", 404);
    req.status = "APPROVED";
    req.adminNote = data?.adminNote || null;
    req.reviewedAt = new Date().toISOString();
    req.reviewedByName = data?.reviewedByName || "Admin";
    const sale = db.sales.find((x) => x.saleId === req.saleId);
    if (sale) sale.status = "CANCELLED";
    save(db);
    return ok(req);
  }
  if ((mt = path.match(/^\/api\/admin\/correction-requests\/(\d+)\/reject$/)) && m === "POST") {
    const id = Number(mt[1]);
    const req = db.corrections.find((x) => x.requestId === id);
    if (!req) return bad("Request not found", 404);
    req.status = "REJECTED";
    req.adminNote = data?.adminNote || null;
    req.reviewedAt = new Date().toISOString();
    req.reviewedByName = data?.reviewedByName || "Admin";
    const sale = db.sales.find((x) => x.saleId === req.saleId);
    if (sale) sale.status = "REJECTED";
    save(db);
    return ok(req);
  }

  // ADMIN SALES
  if (path === "/api/pos/sales/admin/all" && m === "GET") return ok(db.sales);

  // REPORTS use the shared 03:00 → next-day 02:10 business-day window.
  if (path === "/api/admin/reports/daily-sales" && m === "GET") {
    const date = params?.reportDate || currentBusinessDate();
    const sales = db.sales.filter((s) => isInBusinessDay(s.createdAt, date) && s.status !== "CANCELLED");
    const totalBills = sales.length;
    let bottleSales = 0, biteSales = 0, grandTotal = 0;
    sales.forEach((s) => {
      grandTotal += s.grandTotal;
      s.items.forEach((it) => {
        if (it.itemType === "BOTTLE") bottleSales += it.totalPrice;
        else biteSales += it.totalPrice;
      });
    });
    return ok({ reportDate: date, totalBills, bottleSales, biteSales, grandTotal });
  }
  if (path === "/api/admin/reports/payment-summary" && m === "GET") {
    const date = params?.reportDate || currentBusinessDate();
    let cashTotal = 0, cardTotal = 0;
    db.sales.filter((s) => isInBusinessDay(s.createdAt, date) && s.status !== "CANCELLED").forEach((s) => {
      s.payments.forEach((p) => {
        if (p.paymentMethod === "CASH") cashTotal += Number(p.amount);
        else cardTotal += Number(p.amount);
      });
    });
    return ok({ reportDate: date, cashTotal, cardTotal, total: cashTotal + cardTotal });
  }
  if (path === "/api/admin/reports/profit" && m === "GET") {
    const date = params?.reportDate || currentBusinessDate();
    let bottleSalesValue = 0, bottleCost = 0;
    db.sales.filter((s) => isInBusinessDay(s.createdAt, date) && s.status !== "CANCELLED").forEach((s) => {
      const profit = Number(s.profit || 0);
      let val = 0;
      s.items.forEach((it) => {
        if (it.itemType === "BOTTLE") val += it.totalPrice;
      });
      bottleSalesValue += val;
      bottleCost += val - profit;
    });
    return ok({ reportDate: date, bottleSalesValue, bottleCost, bottleProfit: bottleSalesValue - bottleCost });
  }
  if (path === "/api/admin/reports/stock-summary" && m === "GET") {
    const list = db.bottleProducts.map((p) => {
      const e = enrichBottleProduct(db, p);
      return { bottleId: p.bottleId, bottleName: p.bottleName, bottleSize: p.bottleSize, availableQuantity: e.availableQuantity, lowStockLevel: p.lowStockLevel };
    });
    return ok(list);
  }

  // AUDIT
  if (path === "/api/admin/audit-logs" && m === "GET") return ok(db.auditLogs);

  // CASH SESSIONS
  if (path === "/api/admin/cash-sessions" && m === "GET") return ok(db.cashSessions);
  if (path === "/api/pos/cash-session/current" && m === "GET") {
    const cid = Number(params?.cashierId);
    const s = db.cashSessions.find((x) => x.cashierId === cid && x.status === "OPEN");
    return ok(s || null);
  }
  if (path === "/api/pos/cash-session/open" && m === "POST") {
    const cashierId = Number(data.cashierId);
    if (db.cashSessions.find((s) => s.cashierId === cashierId && s.status === "OPEN"))
      return bad("Cash session already open");
    const s = {
      cashSessionId: nextId(db, "cashSession"),
      cashierId,
      cashierName: data.cashierName || "Cashier",
      openedAt: new Date().toISOString(),
      openingCashAmount: Number(data.openingCashAmount || 0),
      closedAt: null,
      cashSalesAmount: 0,
      expectedClosingCash: Number(data.openingCashAmount || 0),
      actualClosingCash: null,
      cashDifference: null,
      status: "OPEN",
    };
    db.cashSessions.unshift(s);
    save(db);
    return created(s);
  }
  if (path === "/api/pos/cash-session/close" && m === "POST") {
    const cashierId = Number(data.cashierId);
    const s = db.cashSessions.find((x) => x.cashierId === cashierId && x.status === "OPEN");
    if (!s) return bad("No open cash session", 404);
    s.actualClosingCash = Number(data.actualClosingCash);
    s.expectedClosingCash = Number(s.openingCashAmount) + Number(s.cashSalesAmount || 0);
    s.cashDifference = s.actualClosingCash - s.expectedClosingCash;
    s.closedAt = new Date().toISOString();
    s.status = "CLOSED";
    save(db);
    return ok(s);
  }

  // NOTIFICATIONS
  if (path === "/api/admin/notification-recipients" && m === "GET") return ok(db.notificationRecipients);
  if (path === "/api/admin/notification-recipients" && m === "POST") {
    const r = { recipientId: nextId(db, "recipient"), ...data, status: "ACTIVE" };
    db.notificationRecipients.push(r);
    save(db);
    return created(r);
  }
  if ((mt = path.match(/^\/api\/admin\/notification-recipients\/(\d+)\/status$/)) && m === "PATCH") {
    const id = Number(mt[1]);
    const r = db.notificationRecipients.find((x) => x.recipientId === id);
    if (!r) return bad("Recipient not found", 404);
    r.status = params?.status || (r.status === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    save(db);
    return ok(r);
  }
  if ((mt = path.match(/^\/api\/admin\/notification-recipients\/(\d+)$/)) && m === "PUT") {
    const id = Number(mt[1]);
    const r = db.notificationRecipients.find((x) => x.recipientId === id);
    if (!r) return bad("Recipient not found", 404);
    Object.assign(r, data, { recipientId: r.recipientId });
    save(db);
    return ok(r);
  }
  if (path === "/api/admin/notification-logs" && m === "GET") return ok(db.notificationLogs);

  return bad(`Mock endpoint not implemented: ${m} ${path}`, 501);
};
